import React, { useState } from "react";
import "./css/followers.css";
import { extractJsonFromZip, findNonFollowers, downloadNonFollowersCSV } from "./followersService";

const Followers = () => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);
  const [nonFollowers, setNonFollowers] = useState([]);
  const [search, setSearch] = useState("");
  const [sortAsc, setSortAsc] = useState(true);

  const UploadInstructions = ({ onFileUpload }) => (
    <>
      <div className="instructions">
        <h2>Instructions</h2>
        <ol>
          <li>Go to your Instagram Profile</li>
          <li>Click on the 3 Horizontal Lines on the top right corner</li>
          <li>Select Accounts Center</li>
          <li>Go to "Your information and permissions"</li>
          <li>Select "Export your information" and Create Export</li>
          <li>Select Instagram, Export to Device</li>
          <li>Select Customize Information</li>
          <li>Deselect Everything Except: "Followers and following", Click Save</li>
          <li>Set Date Range to: "All Time"</li>
          <li>Change Format to be "JSON"</li>
          <li>Start Export</li>
          <li>Upload the Downloaded .Zip File (If on Computer Compress the Folder)</li>
        </ol>
      </div>
      <input type="file" accept=".zip" onChange={onFileUpload} className="file-input" />
    </>
  );

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || file.type !== "application/zip") {
      alert("Please upload a ZIP file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const byteArray = new Uint8Array(e.target.result);
      const extractedData = await extractJsonFromZip(byteArray);

      setFollowers(extractedData.followers1 || []);
      setFollowings(extractedData.following || { relationships_following: [] });
      setNonFollowers(findNonFollowers(extractedData.followers1, extractedData.following));
      setIsUploaded(true);
    };
    reader.readAsArrayBuffer(file);
  };

  const displayedUsers = nonFollowers
    .filter((u) => u.username.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => (sortAsc ? a.username.localeCompare(b.username) : b.username.localeCompare(a.username)));

  return (
    <div className="followers-container">
      {/* Instructions & file upload */}
      {!isUploaded && (
        <div className="instructions-wrapper">
            <UploadInstructions onFileUpload={handleFileUpload} />
        </div>
      )}

      {isUploaded && (
        <>
          {/* Summary */}
          <div className="summary">
            <p>Following: {followings.relationships_following.length}</p>
            <p>Followers: {followers.length}</p>
            <p>Non-Followers: {nonFollowers.length}</p>
          </div>

          {/* Controls */}
          <div className="controls">
            <input
              type="text"
              placeholder="Search non-followers..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
            <button onClick={() => setSortAsc(!sortAsc)} className="sort-button">
              Sort {sortAsc ? "Z → A" : "A → Z"}
            </button>
            <button onClick={() => downloadNonFollowersCSV(nonFollowers)} className="download-button">
              Download CSV
            </button>
          </div>

          {/* Non-followers list */}
          <div className="scrollable-container">
            {displayedUsers.length > 0 ? (
              displayedUsers.map((user, index) => (
                <div key={index} className="json-row">
                  <div className="row-content">
                    <p className="username">{user.username}</p>
                    <div className="button-row">
                      <a
                        href={`https://www.instagram.com/${user.username}/`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="instagram-button"
                      >
                        View Profile
                      </a>
                      <button
                        className="copy-button"
                        onClick={() => navigator.clipboard.writeText(user.username)}
                      >
                        Copy Username
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No non-followers found.</p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Followers;